import SearchCircleIcon from './SearchCircleIcon';

export default SearchCircleIcon;
